import React, { useState, useEffect } from 'react';
import H1 from '../Images/Hma.jpeg';
import L1 from '../Images/logo-w.png';

const GetQuestions = () => {
    const [questions, setQuestions] = useState([]);
    const [filteredQuestions, setFilteredQuestions] = useState([]);
    const [error, setError] = useState(null);

    console.log(error)

    useEffect(() => {
        const fetchQuestions = async () => {
            try {
                const response = await fetch('https://rvapi.emedha.in/pages/api/get/questions');
                if (!response.ok) {
                    throw new Error('Failed to fetch questions');
                }
                const data = await response.json();
                console.log(data);
                setQuestions(data);
                setFilteredQuestions(data);
            } catch (error) {
                setError(error.message);
            }
        };

        fetchQuestions();
    }, []);


    const filterQuestions = (sessionTopic) => {
        console.log(`Filtering by session topic: ${sessionTopic}`);
        if (sessionTopic === 'All') {
            setFilteredQuestions(questions);
        } else {
            const filtered = questions.filter(question => {
                const isMatch = question.sessiontopic.trim().toLowerCase() === sessionTopic.trim().toLowerCase();
                console.log(`Checking question: ${question.sessiontopic} === ${sessionTopic} -> ${isMatch}`);
                return isMatch;
            });
            setFilteredQuestions(filtered);
        }
    };

    return (
        <>
            <div>
                <img src={H1} alt="item" style={{ height: '230px', width: '100%' }} />
                <div className="container mt-5">
                    <div>
                        <button className='btn btn-dark btn-sm me-3' onClick={() => filterQuestions('All')}>All</button>
                        <button className='btn btn-primary btn-sm me-3' onClick={() => filterQuestions('Fire Side Chat')}>Fire Side Chat</button>
                        <button className='btn btn-success btn-sm me-3' onClick={() => filterQuestions('Spirutal Dimension of Leadership')}>Spiritual Dimension of Leadership</button>
                        <button className='btn btn-warning btn-sm me-3' onClick={() => filterQuestions('Scaling the Business')}>Scaling the Business</button>
                        <button className='btn btn-danger btn-sm me-3' onClick={() => filterQuestions('Panel Discussion')}>Panel Discussion</button>
                        <button className='btn btn-info btn-sm me-3' onClick={() => filterQuestions('Leadership Imperatives')}>Leadership Imperatives</button>
                        <button className='btn btn-secondary btn-sm me-3' onClick={() => filterQuestions('Technology in Healthcare')}>Technology in Healthcare</button>
                    </div>

                    <div className='mt-5'>
                        <table className="table table-striped table-bordered table-hover">
                            <thead>
                                <tr className="table-primary">
                                    <th>Session Topic</th>
                                    <th>Name</th>
                                    <th>Question</th>
                                    <th>Top 5</th>
                                </tr>
                            </thead>
                            <tbody>
                                {filteredQuestions.map((question) => (
                                    <tr key={question.slno}>
                                        <td>{question.sessiontopic}</td>
                                        <td>{question.name}</td>
                                        <td>{question.question}</td>
                                        <td>{question.count}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
                <footer style={{ backgroundColor: '#f1f1f1', padding: '10px 0', textAlign: 'center', marginTop: '20px' }}>
                    <div>
                        <p style={{ margin: '0', fontSize: '14px' }}>Powered by
                            <a href="https://emedha.com/" target="_blank" rel="noopener noreferrer" style={{ color: '#4CAF50', textDecoration: 'none', marginLeft: '5px' }}>
                                EMedha Technologies
                            </a>
                        </p>
                        <a href="https://emedha.com/" target="_blank" rel="noopener noreferrer">
                            <img src={L1} alt="EMedha Technologies Logo" style={{ width: '200px', height: 'auto', marginTop: '10px' }} />
                        </a>
                    </div>
                </footer>
            </div>
        </>
    );
};

export default GetQuestions;
